module.exports = __webpack_public_path__ + "img/agronomy4.cecabf3e.png";